































































































































































import { Vue, Component } from 'vue-property-decorator';
import TabsComponent from './tabs.vue';
import { alert } from '@/common/modal';
import { RouteNames } from './_routes';
import { Titles } from '../../common/cache';

// hierarhy select
// @ts-ignore
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { Subscription } from 'vue-rx-decorators';
import { Cache } from '../../common/cache';
import { User, CanvasAccounts, Sessions, Courses, InmateSource } from '@lantern/lantern-sdk';
// --

interface Children {
    id: string;
    label: string;
    children: Children[];
};

@Component({
    components: {
        tabs: TabsComponent,
        Treeselect
    }
})

export default class ImportComponent extends Vue {
    fileCount = 0;
    uploadedFiles: {}[] = [];
    uploadStatus: any;
    uploadFieldName = 'photos';
    uploadError = false;
    errorStatus = 'ERROR';
    formatError = '';
    uniqueNewSections = [] as {courseId: number; sectionName: string}[]; // section to create
    newAndExistingSectionWithId = [] as {courseId: number; sectionId: number; sectionName: string}[];

    uploadLocked = false;
    modal: any = {
        section: {
            show: false
        },
        errorIds: {
            show: false,
            errorIds: [] as string[]

        },
        info: {
            show: false
        }
    }

    parsedDoc: any; // data from server responce with facilityID Sessions.Document
    cvsDataInmatesWithSectionNames: {
            shipTablet: boolean;
            inmateId: string;
            sisUserId?: string | undefined;
            sviscustodyAccout?: string;
            courses?: {
                courseId: number;
                sectionId?: string | undefined;
            }[] | undefined;
        }[] | undefined

    cvsDataInmates = [] as {
            shipTablet: boolean;
            inmateId: string;
            sisUserId?: string | undefined;
            sviscustodyAccout?: string;
            courses?: {
                courseId: number;
                sectionId?: number | undefined;
            }[] | undefined;
        }[]

    allCoursesForAccount: Courses.Course[] = [];
    chunks: string[] = [];
    readyChunks: number = 0

    // #region HIERARCHY
    defaulMessage = 'Please select an account';
    accountSelected: string = this.defaulMessage;
    accountHierarchical: { id: string; label: string; children: Children[]}[] = []

    @Subscription(() => Cache.instance.accounts)
    accounts!: User.CanvasAccounts | {mainAccounts: string[]; subAcccounts: string[]};

    async created() {

        if (this.accounts.mainAccounts.length === 0) {
            const response = await this.$lantern.endpoints.User.getAccounts();

            const accounts = response.data;
            this.$cache.accounts.next(accounts);
        }
        // create accounts Hierarchy
        this.accounts.mainAccounts.forEach((element: string) => {
            const [id, name, parentId] = element.split(':');
            const label = `${id} - ${name}`;
            this.accountHierarchical.push({ id, label, children: [] });
        });

        this.accounts.subAcccounts.forEach((element: string) => {
            const [id, name, parentId] = element.split(':');
            const label = `${id} - ${name}`;
            this.accountHierarchical.forEach((subElement: { id: string; label: string; children: Children[]}) => {
                if (subElement.id === parentId) {
                    subElement.children.push({
                        id,
                        label,
                        children: []
                    });
                } else {
                    this.checkAcountChildren(subElement, id, label, parentId);
                }
            });
        });
    }

    // create accounts Hierarchy util
    checkAcountChildren(subElement: { id: string; label: string; children: Children[]}, id: string, label: string, parentId: string) {
        subElement.children.forEach(element => {
            if (element.id === parentId) {
                element.children.push({
                    id,
                    label,
                    children: []
                });
            } else {
                this.checkAcountChildren(element, id, label, parentId);
            }
        });

    }
    // #endregion HIERARCHY

    private timeout(ms: number) {
        return new Promise((resolve, reject) => setTimeout(resolve, ms));
    }

    // #region FILE
    /**
     * This function was revised from a previous implementation that relied on the `pages` field from the API response to determine pagination.
     * In certain cases, the API was returning null for the `pages` field, causing the function to fail in retrieving all the data. This would only retrieve data
     * from the first page, thus not providing a comprehensive set of courses for a given account.
     * To address this issue, the function has been modified to use a different pagination approach.
     */
    async getAllCoursesForAccount(accountId: string) {
        this.allCoursesForAccount = [];
        let pageNumber = 1;
        let shouldContinue = true;

        while (shouldContinue) {
            // eslint-disable-next-line no-await-in-loop
            const response = await this.$lantern.endpoints.Courses.getAllCourses({ accountId, pageSize: 50, pageNumber });
            this.allCoursesForAccount.push(...response.data.items);

            if (response.data.items.length === 0) {
                shouldContinue = false;
            } else {
                pageNumber++;
                // eslint-disable-next-line no-await-in-loop
                await this.timeout(250);
            }
        }
    }

    // main entrance
    async filesChange(event: any) {
        // const fieldName = event.target.name;
        const fileList = event.target.files;

        if (this.accountSelected === this.defaulMessage) {
            await alert('Please pick an account first');
            event.target.value = '';
            return;
        }

        this.formatError = '';
        if (!fileList.length) return;
        const validExts = ['.xlsx', '.xls', '.csv'];
        const fileExt = fileList[0].name.substring(
            fileList[0].name.lastIndexOf('.')
        );
        if (validExts.indexOf(fileExt) < 0) {
            this.formatError = `Sorry, that is not a valid CSV file: ${fileList[0].name}`;
            event.target.value = '';

            return;
        }

        // get all courses for picked account to match data from file with data from DB
        this.uploadError = false;
        this.uploadLocked = true;

        try {
            await this.getAllCoursesForAccount(this.accountSelected);
        } catch {
            alert(`Error: Cannot load account courses.`);
        }
        // procees file
        this.parseCVSFile(fileList[0]);
        event.target.value = '';

    }

    async parseCVSFile(file: { name: string; size: number }) {
        // this.uploadError = false;
        // this.uploadLocked = true;
        // let uniqueCoursesInFile = [] as {courseId: number; sectionId: string}[];
        try {
            const routParam = this.$route.params;

            if ('facilityId' in routParam) {
                // TODO: split file in chunks
                // make separate requests
                // concat into parsedDoc
                const reader = new FileReader();

                reader.addEventListener('load', async (event) => {
                    this.chunks = [];

                    if (event && event.target && event.target.result) {
                        const data = event.target.result.toString();

                        let startIndex = 0;
                        let index = 0;
                        let lineFeedsFound = 0;
                        for (const char of data) {
                            if (char === '\n') {
                                lineFeedsFound++;
                            }
                            if (lineFeedsFound > 50) {
                                const chunk = data.substring(startIndex, index);
                                this.chunks.push(chunk);
                                startIndex = index + 1;
                                lineFeedsFound = 0;
                            }
                            index++;
                        }
                        const chunk = data.substring(startIndex, index);
                        this.chunks.push(chunk);
                    }

                    console.log(this.chunks.length);
                    let first = true;
                    let allRegistrationCount = 0;
                    let allInmates = [] as any[];
                    const alErrorIds = [] as string[];
                    this.readyChunks = 0;

                    try {
                        for (const chunk of this.chunks) {
                            // console.log({ allRegistrationCount });
                            // eslint-disable-next-line no-await-in-loop
                            const response = await this.$lantern.endpoints.Sessions.importCSV(
                                chunk,
                                routParam.facilityId,
                                this.accountSelected
                            );

                            this.readyChunks += 1;

                            allRegistrationCount += response.data.registrationCount;
                            allInmates.push(...response.data.inmates);
                            alErrorIds.push(...response.data.errorIds);

                            if (first) {
                                this.parsedDoc = { ...response.data };
                                first = false;
                            }
                        }

                        allInmates = allInmates.map((inmate: any) => {
                            inmate.courses = inmate.courses.map((course: any) => {
                                if (course.sectionId) {
                                    course.sectionId = course.sectionId.replace('\r', '');
                                }
                                return course;
                            });
                            return inmate;
                        });

                        const uniqueInmatesHash: {
                            [inmateId: string]: {
                                sisUserId: string;
                                courseId: string;
                                sectionId: string;
                            }[];
                        } = {};

                        allInmates.forEach((inmate: any) => {
                            inmate.courses.forEach((course: any) => {
                                uniqueInmatesHash[inmate.inmateId] = uniqueInmatesHash[inmate.inmateId] || [];

                                if (!uniqueInmatesHash[inmate.inmateId].find(uniqueInmate => uniqueInmate.courseId === course.courseId && uniqueInmate.sectionId === course.sectionId)) {
                                    uniqueInmatesHash[inmate.inmateId].push({
                                        sisUserId: inmate.sisUserId,
                                        courseId: course.courseId,
                                        sectionId: course.sectionId,
                                    });
                                }
                            });
                        });

                        const uniqueInmates: any[] = [];
                        for (const inmateId in uniqueInmatesHash) {
                            const uniqueInmate: any = {
                                inmateId,
                                courses: [] as any[]
                            };

                            const inmateInfos = uniqueInmatesHash[inmateId];
                            for (const inmateInfo of inmateInfos) {
                                uniqueInmate.sisUserId = inmateInfo.sisUserId;
                                uniqueInmate.courses.push({
                                    courseId: inmateInfo.courseId,
                                    sectionId: inmateInfo.sectionId,
                                });
                            }

                            uniqueInmates.push(uniqueInmate);
                        }

                        this.parsedDoc.registrationCount = allRegistrationCount;
                        this.parsedDoc.errorIds = alErrorIds;
                        this.parsedDoc.inmates = uniqueInmates;
                        this.parsedDoc.studentCount = uniqueInmates.length;

                        console.log('parsedDoc', this.parsedDoc);

                    } catch (err: any) {
                        console.log(err);
                        console.log(err.message);
                        console.log(err.code);

                        this.uploadLocked = false;
                        if (err.message = 'Request failed with status code 400') {
                            await alert(`Cannot parse file. Please confirm that it is formatted correctly. ${err.message}`);
                        }
                        await alert(`Error parsing stream: ${err.message}`);

                        return;
                    }
                    console.log(this.parsedDoc);

                    // check if there are any errors with IDs
                    if (this.parsedDoc.errorIds.length !== 0) {
                        this.modal.errorIds.show = true;
                        this.modal.errorIds.errorIds = this.parsedDoc.errorIds;
                        return;
                    }

                    await this.parceDataCSVClient();
                });
                reader.readAsText(file as any);

            }

        } catch (err) {
            console.log(err);
            this.uploadLocked = false;
            await alert(`Error: Cannot parse CSV file, please check that file format.`);
        }

    }

    async parceDataCSVClient() {
        const uniqueCoursesInFile = [] as {courseId: number; sectionId: string}[];

        if ((this.parsedDoc.inmates.length === 0)) {
            await alert('There are no inmates to proccess');
            this.reset();
            return;
        }

        // 1. Check that we have courses and sections for all inmates - give en error if it's not
        const emptyCoursesSections: string[] = this.getemptyCoursesSections();
        if (emptyCoursesSections.length !== 0) {
            let listId = '';
            emptyCoursesSections.forEach(e => {
                listId = `${listId} ${e};`;
            });
            await alert(`Please specify cource / section name for inmate(s): ${listId}`);
            this.reset();
            return;
        }

        // 2. Replace all names in file with real Courses id - add some popup if not found
        const dataWithCoursesId = this.replaceAllCoursesWithDbId(this.parsedDoc);

        if (dataWithCoursesId === undefined) {
            this.reset();
            return;
        }

        // 4. Create list of uniqueue courses and section for creation
        this.cvsDataInmatesWithSectionNames = dataWithCoursesId?.map(el => {
                  // eslint-disable-next-line no-unused-expressions
                  el.courses?.map(course => {
                      // add all section to an array to create them if they not exist
                      if (course.sectionId) {
                          const newCourse = { courseId: course.courseId, sectionId: course.sectionId };
                          if (!uniqueCoursesInFile.find(course => course.courseId === newCourse.courseId && course.sectionId === newCourse.sectionId)) {
                              uniqueCoursesInFile.push(newCourse);
                          }
                      }
                  });
                  return { ...el, shipTablet: false };
        });

        console.log(uniqueCoursesInFile);
        // 5. check existing sections and courses, return id for existin ones and name and 0 as an id for sections we're going to create
        await this.getNotExistingSecctions(uniqueCoursesInFile);
        this.uploadLocked = false;

        // 6. Show popup dialog
        if (this.uniqueNewSections.length !== 0) {
            this.modal.section.show = true;
        } else {
            this.replaceAllSectionNamesWithIds(this.newAndExistingSectionWithId);
            this.enrollOnly();
        }
    }

    getemptyCoursesSections() {
        const inmatesWithEmptyData: string[] = [];
        const source = this.$route.params.facilityId.split(':')[0];
        this.parsedDoc.inmates.map((inmate: any) => {
            let failed = false;
            inmate.courses.forEach((course: {courseId: string; sectionId?: string }) => {
                if (course.courseId === '' || !course.sectionId) failed = true;
            });
            if (failed) {
                if (source === InmateSource.svis) inmatesWithEmptyData.push(inmate.sviscustodyAccout);
                if (source !== InmateSource.svis) inmatesWithEmptyData.push(inmate.inmateId);
            }
            return failed;
        });
        return inmatesWithEmptyData;
    }

    replaceAllCoursesWithDbId(CsvData: Sessions.CsvResponce) {
        // check all courses from CSV and replace SIS or CODE with DB id of the Course to make sure they are exist
        let allCoursesExist = true;
        const dataWithCoursesId = CsvData.inmates.map((el) => {
            const coursesWithId = el.courses?.map(course => {
                const courseWithId: { courseId: number; sectionId?: string | undefined } = { courseId: 0 };

                this.allCoursesForAccount.map(existingCource => {
                    if (course.courseId.trim() === existingCource.sis_course_id?.trim() || course.courseId.trim() === existingCource.course_code.trim()) {
                        courseWithId.courseId = existingCource.id;
                        courseWithId.sectionId = course.sectionId;
                    }
                    return existingCource;

                });
                if (courseWithId.courseId === 0 && allCoursesExist) {
                    alert(`Could not find course: ${course.courseId}`);
                    allCoursesExist = false;
                }
                return courseWithId;
            });
            return { ...el, courses: coursesWithId };
        });

        if (allCoursesExist) {
            return dataWithCoursesId;
        }
        return undefined;
    }

    private async getAllSectionsForCourse(courseId: number): Promise<Courses.Section[]> {
        const pageSize = 50;
        const sections: Courses.Section[] = [];
        const response = await this.$lantern.endpoints.Courses.getSections(courseId, { pageSize, pageNumber: 1 });
        const lastPage = response.data.pages;
        sections.push(...response.data.items);

        for (let pageNumber = 2; pageNumber <= lastPage; pageNumber++) {
            const response2 = await this.$lantern.endpoints.Courses.getSections(courseId, { pageSize, pageNumber });
            sections.push(...response2.data.items);
        }
        return sections;
    }

    async getNotExistingSecctions(uniqueCoursesInFile: {courseId: number; sectionId: string}[]) {

        // check if section exist - get back the id
        // if not exist - return a list, and then create sections
        for (const element of uniqueCoursesInFile.sort((a, b) => a.courseId - b.courseId)) {
            const sections = await this.getAllSectionsForCourse(element.courseId);

            let notExist = true;
            let existingSectionId: number = 0;
            // eslint-disable-next-line array-callback-return
            sections.map(el => {

                if (element.sectionId.trim() === el.sis_section_id?.trim() || element.sectionId.trim() === el.name.trim()) {
                    console.log(`found: ${el.sis_section_id}, ${el.name}, element: ${element.sectionId}, ${element.sectionId.trim()}, coulseId: ${element.courseId}, sectionId: ${el.id}`);
                    notExist = false;
                    existingSectionId = el.id;
                }
            });
            if (notExist) {
                // console.log(`notExist`)
                // this.uniqueNewSections = Array.from(new Set([...this.uniqueNewSections, { courseId: element.courseId, sectionId: existingSectionId, sectionName: element.sectionId }]));

                if (!this.uniqueNewSections.find(e => e.courseId === element.courseId && e.sectionName === element.sectionId)) {
                    this.uniqueNewSections.push({ courseId: element.courseId, sectionName: element.sectionId });
                }
            }

            if (!this.newAndExistingSectionWithId.find(e => e.courseId === element.courseId && e.sectionId === existingSectionId && e.sectionName === element.sectionId)) {
                this.newAndExistingSectionWithId.push({ courseId: element.courseId, sectionId: existingSectionId, sectionName: element.sectionId });
            }

            // this.newAndExistingSectionWithId = Array.from(new Set([...this.newAndExistingSectionWithId, { courseId: element.courseId, sectionId: existingSectionId, sectionName: element.sectionId }]));
        }
        // console.log(`this.uniqueNewSections`);
        // console.log(this.uniqueNewSections);
    }
    // #endregion FILE

    // #region POPUP ACTIONS
    async createSections() {
        this.modal.section.show = false;
        try {
            // add check if course accessible for the User
            const sectionOnlyWithIds: {
                sectionId: any;
                courseId: number;
                sectionName: string;
            }[] = [];
            for (const course of this.newAndExistingSectionWithId) {
                if (course.sectionId === 0) {
                    const res = await this.$lantern.endpoints.Courses.createSection(
                        { name: course.sectionName,
                            startAt: new Date(), endAt: new Date(new Date().getFullYear(), 11, 31) }, { courseId: course.courseId.toString() }
                    );
                    sectionOnlyWithIds.push({ ...course, sectionId: res.data.id });
                } else {
                    sectionOnlyWithIds.push(course);
                }
            }

            // replace rest of name with just created IDs
            this.replaceAllSectionNamesWithIds(sectionOnlyWithIds);

            if (this.cvsDataInmates.length === 0) {
                await alert('No students to register!');
                return;
            }

            // proccess to the confirmation page
            this.$cache.cvsFileData.next({ ...this.parsedDoc, inmates: this.cvsDataInmates });
            this.$router.push({ name: RouteNames.confirmation, params: { title: Titles.cvsFile } });
            this.reset();

        } catch (error) {
            await alert(`Error! Cannot create sections!`);
            this.reset();
        }
    }

    replaceAllSectionNamesWithIds(sectionOnlyWithIds: {courseId: number;sectionId: number; sectionName: string}[]) {

        // eslint-disable-next-line no-unused-expressions
        const results = this.cvsDataInmatesWithSectionNames?.map(el => {
            const courses = el.courses?.map(sectionWithNames => {
                let res = { courseId: sectionWithNames.courseId, sectionId: 0 };
                sectionOnlyWithIds.map(sectionWithId => {
                    if (sectionWithNames.sectionId?.trim() === sectionWithId.sectionName.trim() && sectionWithNames.courseId === sectionWithId.courseId) {
                        res = { courseId: sectionWithId.courseId, sectionId: sectionWithId.sectionId };
                    }
                    return sectionWithId;
                });
                return res;
            });
            return { ...el, courses };
        });

        if (results) this.cvsDataInmates = results;
    }

    async enrollOnly() {
        this.replaceAllSectionNamesWithIds(this.newAndExistingSectionWithId.filter(course => course.sectionId !== 0));

        const inmates = this.cvsDataInmates.filter(inmate => {
            if (inmate.courses) {
                inmate.courses = inmate.courses.filter(course => course.sectionId !== 0);
                return inmate.courses.length;
            }
            return true;

        });

        const studentCount = inmates.length;
        const registrationCount = inmates.reduce((total, inmate) => {
            if (inmate.courses) {
                total += inmate.courses.length;
            }
            return total;
        }, 0);

        if (studentCount === 0) {
            await alert('No students to register!');
            return;
        }

        this.$cache.cvsFileData.next({
            ...this.parsedDoc,
            studentCount,
            registrationCount,
            inmates
        });

        this.$router.push({ name: RouteNames.confirmation, params: { title: Titles.cvsFile } });
        this.reset();
    }

    async proceedWithErrors(go: boolean) {
        if (go) {
            this.modal.errorIds.show = false;
            this.chunks = [];
            this.readyChunks = 0;
            await this.parceDataCSVClient();
        } else {
            this.modal.errorIds.show = false;
            this.reset();
        }

    }

    async showDetail() {
        this.modal.info.show = true;
    }

    async downloadTestCSV() {

        const rows = [
            ['id', 'sis id', 'course', 'section'],
            ['120285', 'b-112', 'COM-101', '1B'],
            ['120286', 'b-112', 'COM-101', '1B']
        ];

        const csvContent = `data:text/csv;charset=utf-8,${
            rows.map(e => e.join(',')).join('\n')}`;

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'example.csv');
        document.body.appendChild(link); // Required for FF

        link.click();

    }
    // #endregion POPUP ACTIONS

    reset() {
        this.uploadedFiles = [];
        this.allCoursesForAccount = [];
        this.uploadLocked = false;

        this.uniqueNewSections = [];
        this.parsedDoc = null;
        this.cvsDataInmates = [];
        this.modal.section.show = false;
        this.cvsDataInmatesWithSectionNames = undefined;
        this.chunks = [];
        this.readyChunks = 0;
    }
}
